import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.validate.js";
import "LIBS/jquery.validate.unobtrusive.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.NicknameModal
*
* Encapsulates the functionality of a modal dialog for creating/updating user nickname
**/
HSN.NicknameModal = (function (parent) {
    __extends(NicknameModal, parent);

    /**
    * new HSN.NicknameModal()
    **/
    function NicknameModal() {
        this.name = 'HSN.NicknameModal';

        return NicknameModal.__super__.constructor.call(this, "nickname");
    }

    /**
    * HSN.NicknameModal#Show() -> void
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    NicknameModal.prototype._show = function () {
        var scope = this;

        $.ajax({
            type: 'GET',
            url: "/nickname?" + "refurl=" + document.URL + "&" + new Date().getTime(),
            dataType: 'html',
            success: function (data) {
                scope.Root.removeClass('loading');

                scope.DisplayModal(data, 0);
            },
            error: function () {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for modal form, use ajax to retrieve response, and update modal content
    **/
    NicknameModal.prototype.SubmitForm = function () {
        var scope = this;

        var form = $('form', scope.Content);

        //manually run client validation since we arent running submit operation
        if (!form.valid())
            return;

        $.ajax({
            type: 'POST',
            url: '/nickname?' + new Date().getTime(),
            dataType: 'html',
            contentType: 'application/x-www-form-urlencoded',
            data: form.serialize()
        })
            .done(function (data) {
                scope.DisplayModal(data, 0);
            })
            .fail(function () {
                alert('error submitting review');
            });
    };

    NicknameModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time,
            function () {
                //needed for unobtrusive client side validation for ajax loaded form
                $.validator.unobtrusive.parse($('form', scope.Content));
                scope.Center();
                scope.Content.animate({ opacity: 1 });
            },
            function () {
                //scope.Center();
            });
    };

    return NicknameModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/NicknameModal.js